export const partners = ["asurion", "verizon", "att", "tmobile", "cricket", "adt", "youtubetv", "amazonrouter"];
export const lobs = ["soluto", "mobility", "care"];
